<template>
  <div class="game-container" :style="getStyle(startGameConfig)">
    <div class="header" v-if="startGameConfig.header" :style="getStyle(startGameConfig.header)">
      <div class="header__title" v-if="startGameConfig.header.title" :style="getStyle(startGameConfig.header.title)">
        {{ startGameConfig.header.title.txt }}
      </div>
      <div
        class="header__tagline"
        v-if="startGameConfig.header.tagline"
        :style="getStyle(startGameConfig.header.tagline)"
      >
        {{ startGameConfig.header.tagline.txt }}
      </div>
    </div>
    <div class="content">
      <svg width="600" height="500" viewBox="0 0 600 500" class="svg">
        <template v-for="(item, i) in items">
          <rect :key="'rect_' + i" @click="goTo(i)" class="box" :x="45 + 30 * i" y="15" width="30" height="30" />
          <circle :key="'circle_' + i" :cx="60 + 30 * i" cy="30" r="5" fill="#e0e0e0" />
        </template>
      </svg>

      <div class="desc" v-if="startGameConfig.items[curIndex].desc">
        <div
          class="desc__title"
          v-if="startGameConfig.items[curIndex].desc.title"
          v-html="startGameConfig.items[curIndex].desc.title"
        ></div>
        <div
          class="desc__body"
          v-if="startGameConfig.items[curIndex].desc.txt"
          v-html="startGameConfig.items[curIndex].desc.txt"
        ></div>
      </div>
    </div>
  </div>
</template>

<script>
import _ from 'lodash';
import anime from 'animejs';

import defaultMixins from '../../mixins/defaultMixin';
import svgMixins from '../../mixins/svgMixin';

export default {
  name: 'mp-gallery-svg',
  mixins: [defaultMixins, svgMixins],
  components: {},
  props: {
    startGameConfig: {
      type: Object,
      default: function () {
        return {};
      },
    },
  },
  data() {
    return {
      svgStage: null,
      ts: [],
      curIndex: 0,
      timeId: null,
      slideTimeout: 7000,
      svg: null,
      items: [],
    };
  },
  beforeMount() {
    this.initGame();
  },
  mounted() {
    this.newGame();
  },
  methods: {
    initGame() {
      this.items = [];
      this.ts = [];
      for (let i = 0; i < this.startGameConfig.items.length; i++) {
        this.$set(this.items, i, []);
        this.$set(this.ts, i, []);
        this.readTextFile(this.startGameConfig.items[i].svg, i);
      }
    },

    newGame() {
      this.svg = document.querySelector('.svg');
      let self = this;

      this.items[0].forEach(function (path) {
        let newPath = document.createElementNS('https://www.w3.org/2000/svg', 'path');

        self.svg.append(newPath);

        newPath.setAttribute('id', path.id.replace('#', ''));
        let tmp = _.cloneDeep(path);
        delete tmp.id;
        delete tmp.d;
        let str = '';
        for (var p in tmp) {
          if (tmp.hasOwnProperty(p)) {
            newPath.setAttribute(p, tmp[p]);
          }
        }
        newPath.setAttribute('d', path.d);
      });

      setTimeout(() => {
        if (document.querySelector('.desc__body') !== null)
          document.querySelector('.desc__body').innerHTML = self.startGameConfig.items[0].desc.txt;
        if (document.querySelector('.desc__title') !== null)
          document.querySelector('.desc__title').textContent = self.startGameConfig.items[0].desc.title;
      }, 200);

      /*




                 document.addEventListener(
                 "keydown",
                 function(event) {
                 if (event.keyCode >= 49 && event.keyCode <= 53) {
                 restartAnimation(event.keyCode - 49);
                 } else if (event.keyCode === 37) {
                 // left
                 restartAnimationPrev();
                 } else if (event.keyCode === 39) {
                 // right
                 restartAnimationNext();
                 }
                 },
                 false
                 );


                 */

      this.timeId = setTimeout(this.slideshow, this.slideTimeout);
    },

    readTextFile(file, idx) {
      let rawFile = new XMLHttpRequest(),
        self = this;
      rawFile.open('GET', file, false);
      rawFile.onreadystatechange = function () {
        if (rawFile.readyState === 4) {
          if (rawFile.status === 200 || rawFile.status == 0) {
            let _file = rawFile.responseText,
              _tag = document.createElement('div');
            _tag.innerHTML = _file;
            let svg = _tag.getElementsByTagName('svg')[0];
            for (let j = 0; j < svg.children.length; j++) {
              let obj = {};
              for (let att, i = 0, atts = svg.children[j].attributes, n = atts.length; i < n; i++) {
                att = atts[i];
                obj[att.nodeName] = att.nodeValue;
              }
              self.$set(self.items[idx], self.items[idx].length, obj);
            }
          }
        }
      };
      rawFile.send(null);
    },

    show(idx, withDelay) {
      this.ts[idx].length = 0;
      var self = this;
      this.items[
        ((idx + (this.items.length - 1)) % this.items.length) + 1 === this.items.length
          ? 0
          : ((idx + this.items.length - 1) % this.items.length) + 1
      ].forEach(function (path, i) {
        var delay = withDelay ? 10 * i : 0;
        self.ts[idx].push(
          new anime({
            targets: path.id,
            d: {
              value: path.d,
              duration: 1000,
              easing: 'easeInOutQuad',
            },
            fill: {
              value: path.fill,
              duration: 1000,
              easing: 'easeInOutQuad',
            },
            delay: delay,
          })
        );
      });
    },

    play(idx) {
      this.ts[idx].forEach(function (a) {
        a.play();
      });
    },

    prev() {
      this.curIndex--;
      if (this.curIndex < 0) this.curIndex = this.items.length - 1;
    },

    next() {
      this.curIndex++;
      this.curIndex %= this.items.length;
    },

    resetAnimations(idx) {
      this.ts.forEach(function (t) {
        if (t)
          t.forEach(function (a) {
            a.pause();
          });
      });
      this.show(idx, false);
      this.play(idx);
      this.curIndex = idx;
      clearTimeout(this.timeId);
      this.timeId = setTimeout(this.slideshow, this.slideTimeout);
    },

    restartAnimation(idx) {
      this.resetAnimations(idx);
    },

    restartAnimationPrev() {
      this.prev();
      this.resetAnimations(this.curIndex);
    },

    restartAnimationNext() {
      this.next();
      this.resetAnimations(curIndex);
    },

    advance() {
      this.next();
      this.show(this.curIndex, true);
      this.play(this.curIndex);
    },

    goTo(idx) {
      this.restartAnimation(idx);
    },

    slideshow() {
      this.advance();
      this.timeId = setTimeout(this.slideshow, this.slideTimeout);
    },

    resetGameAction() {
      this.newGame();
    },
    getStyle(item) {
      // padding: 5%;
      // margin-top: 12%;
      return _.merge({}, this.getCustomStyle(item));
    },
    getCustomStyle(item) {
      let customStyle = {};
      if (item !== undefined && item.cssStyle) {
        if (_.isObject(item.cssStyle)) {
          customStyle = _.mapKeys(item.cssStyle, function (value, key) {
            return _.toString(key);
          });
        }
      }
      return customStyle;
    },
  },
  beforeDestroy() {
    clearTimeout(this.timeId);
  },
};
</script>
<style lang="scss"></style>
<style lang="scss" scoped>
.game-container {
  display: flex;
  padding-top: 120px;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  width: 100%;
  height: 100%;

  font-family: Inconsolata, sans-serif;
  font-size: 18px;
  margin: 0;
}

.header {
  margin: 30px;
}

.header__title {
  display: inline-block;
  font-weight: bold;
  margin-right: 20px;
}

.header__tagline {
  display: inline-block;
}

.content {
  align-items: center;
  display: flex;
  margin: 0 auto;
  max-width: 960px;
  width: 100%;
}

@media all and (max-width: 768px) {
  .content {
    flex-direction: column;
  }
}

svg {
  flex-shrink: 1;
  height: auto;
  max-width: 600px;
  width: 100%;
}

.desc {
  box-sizing: border-box;
  flex-shrink: 0;
  line-height: 1.44;
  padding: 0 20px;
  width: 320px;
}

@media all and (max-width: 768px) {
  .desc {
    max-width: 600px;
    width: 100%;
    padding: 20px;
  }
}

.desc__title {
  font-size: 50px;
  font-weight: bold;
  margin-bottom: 20px;
}

@media all and (max-width: 768px) {
  .desc__title {
    font-size: 32px;
  }
}

.box {
  fill: #fff;
  cursor: pointer;
}

.box:hover {
  fill: #f2f2f2;
}
</style>
